import React, { Component } from "react";
import { Form } from "react-bootstrap";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../navigationSection/BottomNavigationMobile";
import { TopTextReusableComponent } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import ReservationScreen from "./InsideSubscriptionScreen/ReservationScreen";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import isEmpty from "../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../Loader/AmealioLoader";

export class ReservationSubscriptionEditScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editButton: false,
      actionButton: false,
      loader: false,
      hasSetSubscriptionProps: false,
      openModal: false,
      reservationTableAroundTime: false,
      reservationTableAroundTimeText: "",
      //Walkin Waitlist States
      //Reservation State
      minimumPersonReservation: "",
      reservationTableKeptForPopup: false,
      reservationTableKeptFor: "",
      sameDayAllowed: false,
      reservationMinLead: false,
      reservationMinLeadTime: "",
      reservationCutOffTime: false,
      reservationCutOffTimeText: "",
      maximumDays: "",
      reservationCapacity: "",
      reservationTimeSlots: false,
      reservationTimeSlotsText: "",
      errors: {},
      resTabKeptForError: false,
      resMinLeadTimeError: false,
      resCutOffTimeError: false,
      resTimeSlotError: false,
    };
    this.sameDayAllowed = this.sameDayAllowed.bind(this);
  }

  componentDidMount() {
    if (this.props.auth.loader) {
      this.setState({
        loader: this.props.auth.loader,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.onboarding._id) &&
      !isEmpty(nextProps.subscription) &&
      !nextState.hasSetSubscriptionProps
    ) {
      return {
        reservation: !isEmpty(nextProps.onboarding.reservation)
          ? nextProps.onboarding.reservation
          : false,
        requestPeriod: !isEmpty(nextProps.onboarding.request_period)
          ? nextProps.onboarding.request_period
          : "",
        minimumPerson: !isEmpty(nextProps.onboarding.minimum_person)
          ? nextProps.onboarding.minimum_person
          : "",
        minimumPersonReservation: !isEmpty(
          nextProps.onboarding.minimum_person_reservation
        )
          ? nextProps.onboarding.minimum_person_reservation
          : "",
        reservationTableKeptFor: !isEmpty(
          nextProps.onboarding.reservation_table_kept_for
        )
          ? nextProps.onboarding.reservation_table_kept_for
          : "",
        sameDayAllowed: !isEmpty(nextProps.onboarding.sameDayAllowed)
          ? nextProps.onboarding.sameDayAllowed
          : false,
        reservationMinLeadTime: !isEmpty(nextProps.onboarding.minimum_lead_time)
          ? nextProps.onboarding.minimum_lead_time
          : "",
        reservationCutOffTimeText: !isEmpty(nextProps.onboarding.cut_off_time)
          ? nextProps.onboarding.cut_off_time
          : "",
        maximumDays: !isEmpty(nextProps.onboarding.maximum_days)
          ? nextProps.onboarding.maximum_days
          : "",
        reservationCapacity: !isEmpty(nextProps.onboarding.reservation_capacity)
          ? nextProps.onboarding.reservation_capacity
          : "",
        reservationTimeSlotsText: !isEmpty(
          nextProps.onboarding.reservation_time_slot
        )
          ? nextProps.onboarding.reservation_time_slot
          : "",
        hasSetSubscriptionProps: true,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      console.log(nextProps.auth.loader);
      return {
        loader: nextProps.auth.loader,
      };
    }
    return null;
  }

  /****************************************************************
   * @DESC Seating Area Page All Functions Start
   ****************************************************************/

  onChange = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    this.setState({
      [e.target.name]: number,
      errors: {},
      actionButton: true,
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
      actionButton: true,
    });
  };

  /*********************************************
   * @DESC Reservation Table Around Time Model
   ********************************************/

  reservationTableAroundTimeOpen = () => {
    this.setState({
      reservationTableAroundTime: true,
      actionButton: true,
    });
  };

  reservationTableAroundTimeClosed = () => {
    this.setState({
      reservationTableAroundTime: false,
    });
  };

  reservationTableAroundTimeTextButtonClick = (e, type) => {
    e.preventDefault();
    this.setState({
      tableturnAroundTime: type,
      reservationTableAroundTime: false,
    });
  };

  onClickDisplayScreen = (e) => {
    e.preventDefault();
    this.setState({
      displayScreen: true,
    });
  };
  onClickDisplayScreenClosed = (e) => {
    e.preventDefault();
    this.setState({
      displayScreen: false,
    });
  };

  /****************************************************************
   * @DESC Walkin Waitlist Page All Functions Start
   ****************************************************************/
  onChangeWalkinWaitlist = (e) => {
    let { value, min, max, maxLength } = e.target;
    value =
      Math.max(Number(min), Math.min(Number(max), Number(value))) ||
      value.slice(0, maxLength);
    this.setState({
      [e.target.name]: value,
      errors: {},
      actionButton: true,
    });
  };

  /****************************************************************
   * @DESC Reservation Page All Functions start
   ****************************************************************/
  sameDayAllowed(sameDayAllowed) {
    this.setState({
      sameDayAllowed,
      actionButton: true,
    });
  }

  /************************************
   * @DESC Reservation Table Kept for Model
   ***********************************/

  reservationTableKeptOpen = () => {
    this.setState({
      resTabKeptForError: true,
      reservationTableKeptForPopup: true,
    });
  };

  reservationTableKeptClosed = () => {
    this.setState({
      resTabKeptForError: true,
      reservationTableKeptForPopup: false,
      actionButton: false,
    });
  };

  reservationTableKeptButtonClick = (e, type) => {
    e.preventDefault();
    this.setState({
      reservationTableKeptFor: type,
      reservationTableKeptForPopup: false,
      resTabKeptForError: false,
      actionButton: true,
    });
  };

  /************************************
   * @DESC Reservation Min Lead Model
   ***********************************/

  reservationMinLeadOpen = () => {
    this.setState({
      resMinLeadTimeError: true,
      reservationMinLead: true,
    });
  };

  reservationMinLeadClosed = () => {
    this.setState({
      resMinLeadTimeError: true,
      reservationMinLead: false,
      actionButton: false,
    });
  };

  reservationMinLeadTimeButtonClick = (e, type) => {
    e.preventDefault();
    this.setState({
      reservationMinLeadTime: type,
      reservationMinLead: false,
      resMinLeadTimeError: false,
      actionButton: true,
    });
  };

  /************************************
   * @DESC Reservation Cut Off Time Model
   ***********************************/

  reservationCutOffTimeOpen = () => {
    this.setState({
      resCutOffTimeError: true,
      reservationCutOffTime: true,
    });
  };

  reservationCutOffTimeClosed = () => {
    this.setState({
      resCutOffTimeError: true,
      reservationCutOffTime: false,
      actionButton: false,
    });
  };

  reservationCutOffTimeButtonClick = (e, type) => {
    e.preventDefault();
    this.setState({
      reservationCutOffTimeText: type,
      reservationCutOffTime: false,
      resCutOffTimeError: false,
      actionButton: true,
    });
  };

  /************************************
   * @DESC Reservation Time Slots Model
   ***********************************/

  reservationTimeSlotsOpen = () => {
    this.setState({
      resTimeSlotError: true,
      reservationTimeSlots: true,
    });
  };

  reservationTimeSlotsClosed = () => {
    this.setState({
      resTimeSlotError: true,
      reservationTimeSlots: false,
      actionButton: false,
    });
  };

  reservationTimeSlotsButtonClick = (e, type) => {
    e.preventDefault();
    this.setState({
      reservationTimeSlotsText: type,
      reservationTimeSlots: false,
      resTimeSlotError: false,
      actionButton: true,
    });
  };

  editClick = (e) => {
    this.setState({
      editButton: !this.state.editButton,
    });
  };

  onHandleSubmit = (e) => {
    e.preventDefault();
    if (this.props.onboarding._id && this.props.auth.user.VendorUser._id) {
      const formData = {
        vendor_id: this.props.onboarding.vendor_id,
        id: this.props.onboarding._id,
        table_turn_around: this.state.tableturnAroundTime,
        walk_in_or_waitlist: this.state.walkinWaitlist,
        reservation: this.state.reservation,
        request_period: this.state.requestPeriod,
        minimum_person: this.state.minimumPerson,
        walk_in_wait_list_table_kept_for: this.state.walkinWaitlistTableKeptFor,
        minimum_person_reservation: this.state.minimumPersonReservation,
        reservation_table_kept_for: this.state.reservationTableKeptFor,
        sameDayAllowed: this.state.sameDayAllowed,
        minimum_lead_time: this.state.reservationMinLeadTime,
        cut_off_time: this.state.reservationCutOffTimeText,
        maximum_days: this.state.maximumDays,
        reservation_capacity: this.state.reservationCapacity,
        reservation_time_slot: this.state.reservationTimeSlotsText,
      };
      this.props.create_and_update_restaurant(formData);
    }
  };

  renderReservationsScreen = () => {
    return (
      <React.Fragment>
        <div className="subscription_component_onboarding_main">
          <ReservationScreen
            onReservationChangeHandler={this.onReservationsChangeHandler}
            onReservationSubmit={this.onReservationsSubmit}
            state={this.state}
            errors={this.state.errors}
            onChange={this.onChangeWalkinWaitlist}
            onFocusOut={this.onFocusOut}
            reservationTableKeptOpen={this.reservationTableKeptOpen}
            reservationTableKeptClosed={this.reservationTableKeptClosed}
            reservationTableKeptButtonClick={
              this.reservationTableKeptButtonClick
            }
            sameDayAllowed={this.sameDayAllowed}
            reservationMinLeadOpen={this.reservationMinLeadOpen}
            reservationMinLeadClosed={this.reservationMinLeadClosed}
            reservationMinLeadTimeButtonClick={
              this.reservationMinLeadTimeButtonClick
            }
            reservationCutOffTimeOpen={this.reservationCutOffTimeOpen}
            reservationCutOffTimeClosed={this.reservationCutOffTimeClosed}
            reservationCutOffTimeButtonClick={
              this.reservationCutOffTimeButtonClick
            }
            reservationTimeSlotsOpen={this.reservationTimeSlotsOpen}
            reservationTimeSlotsClosed={this.reservationTimeSlotsClosed}
            reservationTimeSlotsButtonClick={
              this.reservationTimeSlotsButtonClick
            }
          />
        </div>
      </React.Fragment>
    );
  };

  render() {
    if (this.state.loader) {
      return (
        <React.Fragment>
          <AmealioLoader />
        </React.Fragment>
      );
    }
    // const { editButton } = this.state;
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>

            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/seatingdashboard"
                displayText="Back"
              />
              <div className="col-12 onboarding_process_screen_left bg-transparent pt-md-0 pt-lg-0 pt-xl-0">
                <div>
                  <TopTextReusableComponent
                    headingText="Reservation Settings"
                    displayEdit={this.state.editButton}
                    onClickEdit={this.editClick}
                  />
                </div>
                <Form noValidate onSubmit={this.onHandleSubmit}>
                  <div className="onboarding_process_screen-left-mapinside">
                    {this.renderReservationsScreen()}
                  </div>
                </Form>
              </div>
            </div>
            <div className="bottom-panel">
              <BottomNavigationMobile />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

ReservationSubscriptionEditScreen.propTypes = {
  onboarding: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  subscription: state.category.seating_area,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
})(withRouter(ReservationSubscriptionEditScreen));
